import { Component, inject, input, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {
  DesignSystemModule,
  ThemeSwitcherService,
} from '@sanopass-frontend/design-system';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DesignSystemModule],
  template: ` <app-toast-v2 />
    @if (routerReady()) {
      <router-outlet />
    }`,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected title = 'sanopass-spa-admin';
  readonly route = input.required<string>();
  readonly params = input<string | null>(null);
  readonly routerReady = signal(false);

  private readonly router = inject(Router);
  private readonly themeSwitcher = inject(ThemeSwitcherService);

  async ngOnInit() {
    this.themeSwitcher.setTheme(['brand-sanopass-admin']);

    const route = this.route();
    console.log('Input: ', route);

    if (this.params()) {
      const params = JSON.parse(<string>this.params());

      console.log('params: ', params);
      await this.router.navigate([route], {
        queryParams: params,
        skipLocationChange: true,
        replaceUrl: true,
      });
      this.routerReady.set(true);
    } else {
      await this.router.navigate([route], {
        skipLocationChange: true,
      });
      this.routerReady.set(true);
    }
  }
}
